var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AccountApi } from "../api/accountApi";
import { setProfilePhotoUrl } from "../../redux/context/actions";
export const useProfilePhotoAutoRefresh = () => {
    const dispatch = useDispatch();
    const hasProfilePhoto = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.context) === null || _a === void 0 ? void 0 : _a.hasProfilePhoto; });
    const hasStartedRef = useRef(false);
    const lastRefreshRef = useRef(0);
    const refreshNow = () => __awaiter(void 0, void 0, void 0, function* () {
        const now = Date.now();
        if (now - lastRefreshRef.current < 5000)
            return;
        lastRefreshRef.current = now;
        try {
            const url = yield AccountApi.getProfilePhotoUrlAutoRefresh(true);
            dispatch(setProfilePhotoUrl(url));
        }
        catch (_a) { }
    });
    useEffect(() => {
        if (hasProfilePhoto && !hasStartedRef.current) {
            hasStartedRef.current = true;
            AccountApi.startProfilePhotoUrlAutoRefresh({
                onRefresh: (newUrl) => {
                    dispatch(setProfilePhotoUrl(newUrl));
                },
            });
        }
        if (!hasProfilePhoto && hasStartedRef.current) {
            hasStartedRef.current = false;
            AccountApi.stopProfilePhotoUrlAutoRefresh();
        }
        return () => {
            AccountApi.stopProfilePhotoUrlAutoRefresh();
            hasStartedRef.current = false;
        };
    }, [hasProfilePhoto, dispatch]);
    useEffect(() => {
        if (!hasProfilePhoto)
            return;
        const onVisible = () => {
            if (document.visibilityState === "visible")
                refreshNow();
        };
        const onFocus = () => refreshNow();
        document.addEventListener("visibilitychange", onVisible);
        window.addEventListener("focus", onFocus);
        return () => {
            document.removeEventListener("visibilitychange", onVisible);
            window.removeEventListener("focus", onFocus);
        };
    }, [hasProfilePhoto]);
};
